<script lang="ts" setup>
import { useChecklistControllerStore } from "~/composables/useChecklistControllerStore";
const documentId = inject("documentId") as any;

const { nextStep } = useChecklistControllerStore(documentId);
</script>

<template>
  <div class="p-2">
    <BaseLabelBadge class="text-body-1 mb-4">
      As you begin the guided review, confirm you have completed each item. If
      necessary, click edit, fix your paper, and begin the Guided Review again.
    </BaseLabelBadge>
    <div class="flex flex-row justify-end">
      <BaseButton @click="nextStep">
        <span class="flex flex-row items-center gap-2">
          <span> Begin Guided Review </span>
          <BaseIconArrowRight class="mt-[1px]" />
        </span>
      </BaseButton>
    </div>
  </div>
</template>

<style scoped></style>
